import { LiveStreamErrorCode } from './LiveStreamErrorCode';
export class HybridProducerNotReadyError {
    constructor() {
        this.code = LiveStreamErrorCode.HybridProducerNotReady;
        this.message = 'The RealTime Recorder for this location is not ready to be configured.';
        this.name = LiveStreamErrorCode.HybridProducerNotReady;
    }
}
